import React from 'react';
import styled from 'styled-components/macro';
import { ReactComponent as ClockIcon } from 'assets/icons/clock.svg';
import { useFormatMessage } from 'components/IntlProvider';

const WaitingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const WaitingWrap = styled.div`
  max-width: 25rem;
  text-align: center;
  color: #253858;
`;

const WaitingTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  line-height: 2rem;
`;

const WaitingDescription = styled.p`
  font-size: 1rem;
  line-height: 1.5rem;
  color: #5c6370;
  margin: 0 0 1.5rem;
`;

const ButtonLinkStyled = styled.a`
  background-color: #ffffff;
  border: 1px solid;
  color: #144bb8;
  border-radius: 1.5rem;
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  display: inline-block;
  transition: all 0.2s ease-in;

  &:hover {
    background-color: #1656e9;
    color: #ffffff;
  }
`;

const WaitingPlaceholder = () => {
  const t = useFormatMessage();
  return (
    <WaitingContainer>
      <WaitingWrap>
        <ClockIcon />
        <WaitingTitle>
          {t('waiting.title', 'Waiting for respondents')}
        </WaitingTitle>
        <WaitingDescription>
          {t(
            'waiting.description',
            'We will automatically send the survey to your customers as soon as you receive a paid invoice on the bexio platform.'
          )}
        </WaitingDescription>
        <ButtonLinkStyled
          target="_blank"
          rel="noopener noreferrer"
          href="https://deeptrue.atlassian.net/servicedesk/customer/portal/1"
        >
          {t('waiting.cta', 'Report a Problem')}
        </ButtonLinkStyled>
      </WaitingWrap>
    </WaitingContainer>
  );
};

export default WaitingPlaceholder;
